import Vue from "vue";
import VueRouter from "vue-router";
import Profile from "../views/Profile.vue";
import ProfileNew from "../views/ProfileNew.vue";
import Regis from "../views/Regis.vue";
import Unlinkdone from "../views/Unlinkdone.vue";
import CheckBalance from "../views/CheckBalance.vue";
import CheckBalanceNoneRegis from "../views/CheckBalanceNoneRegis.vue";
import Pay from "../views/Pay.vue";
import Paymentgenerate from "../views/Paymentgenerate.vue";
import CheckOtpUpdateAddress from "../views/CheckOtpUpdateAddress.vue";
import UpdateAddress from "../views/UpdateAddress.vue";
import UpdateAddressNoRegisAuth from "../views/UpdateAddressNoRegisAuth.vue";
import UpdateAddressNoRegisForm from "../views/UpdateAddressNoRegisForm.vue";
import Loading from "../views/Loading.vue";
import ChangePhone from "../views/ChangePhone.vue";
import ChangeAddress from "../views/ChangeAddress.vue";
import SelectAddress from "../views/SelectAddress.vue";
import SelectAddressNoRegis from "../views/SelectAddressNoRegis.vue";
import PdpaMkt from "../views/PdpaMkt.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Loading",
    component: Loading,
  },
  {
    path: "/profile",
    name: "Profile",
    component: ProfileNew,
  },
  {
    path: "/profile-new",
    name: "ProfileNew",
    component: ProfileNew,
  },
  {
    path: "/profile-old",
    name: "ProfileOld",
    component: Profile,
  },
  {
    path: "/regis",
    name: "Regis",
    component: Regis,
  },
  {
    path: "/unlinkdone",
    name: "Unlinkdone",
    component: Unlinkdone,
  },
  {
    path: "/checkbalance",
    name: "CheckBalance",
    component: CheckBalance,
  },
  {
    path: "/checkbalancenoneregis",
    name: "CheckBalanceNoneRegis",
    component: CheckBalanceNoneRegis,
  },
  {
    path: "/pay",
    name: "Pay",
    component: Pay,
  },
  {
    path: "/paymentgenerate",
    name: "Paymentgenerate",
    component: Paymentgenerate,
  },
  {
    path: "/checkOtpUpdateAddress",
    name: "CheckOtpUpdateAddress",
    component: CheckOtpUpdateAddress,
  },
  {
    path: "/updateAddress",
    name: "UpdateAddress",
    component: UpdateAddress,
  },
  {
    path: "/updateAddressNoRegisAuth",
    name: "UpdateAddressNoRegisAuth",
    component: UpdateAddressNoRegisAuth,
  },
  {
    path: "/updateAddressNoRegisForm",
    name: "UpdateAddressNoRegisForm",
    component: UpdateAddressNoRegisForm,
  },
  {
    path: "/changePhone",
    name: "ChangePhone",
    component: ChangePhone,
  },
  {
    path: "/changeAddress",
    name: "ChangeAddress",
    component: ChangeAddress,
  },
  {
    path: "/selectAddress",
    name: "SelectAddress",
    component: SelectAddress,
  },
  {
    path: "/selectAddressNoRegis",
    name: "SelectAddressNoRegis",
    component: SelectAddressNoRegis,
  },
  {
    path: "/pdpa-mkt",
    name: "PdpaMkt",
    component: PdpaMkt,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
